<div id="modalvehicles">
  <div class="modal-content" style="padding-bottom: 50px; padding: 3em 4.5em">
    <div class="d-flex justify-content-between mx-auto" style="width: 98%">
      <!-- Header Title -->
      <div *ngIf="service && service['vehicles'] && service['vehicles'][0]['vehicle'].type"  class="d-flex flex-column">
        <p class="usb-modal-text--header mb-0 mt-2">
          {{ service["vehicles"][0]["vehicle"].type }}
        </p>
        <p class="usb-modal-text--body-strong light" style="font-size: 15px;">Traslado {{ service["vehicles"][0]?.transferType }}</p>
      </div>

      <div *ngIf="vehicles && vehicles.length > 0 && vehicles[0]['vehicle']?.type"  class="d-flex flex-column">
        <p class="usb-modal-txt--header mb-0 mt-2">
          {{ vehicles[0]["vehicle"]?.type }}
        </p>
        <p class="usb-modal-text--body-strong light" style="font-size: 15px;">Traslado {{ vehicles[0]?.transferType }}</p>
      </div>

      <!-- Close Button -->
      <button type="button" class="close btn-closed" aria-label="Close" (click)="close()">
        <span aria-hidden="true" style="font-size: 60px; font-weight: 100">&times;</span>
      </button>
    </div>

    <div class="modal-body py-2">
      <usb-vehicle
        [vehicles]="service['vehicles'] || vehicles"
        [infoTransfer]="form"
        [fliyingInfo]="fliyingInfo"
        [formTransport]="formTransport"
        [clientSetting]="clientSetting"
        [currencies]="currencies"
        [currencyAgency]="currencyAgency"
        [paymentAgencyActive]="paymentAgencyActive"
        [tabActive]="tabActive"
        [payload]="payload"
        [action]="action"
        [arrayResults]="arrayResults"
        [quote]="quote"
        (selectVehicleContinue)="continue($event)"
        (selectOneVehicleDoubleWay)="selectOneVehicleDoubleWay($event)"
        (closeModalComents)="close()"
      >
      </usb-vehicle>
    </div>
  </div>
</div>
